import errorImages from "common/constants/errorImages";

import EmptyPage from "../layouts/EmptyPage";
import Body from "../layouts/Body";
import StreamlinedHeader from "../header/StreamlinedHeader";
import ErrorContainer from "./ErrorContainer";

import styles from "../../styles/ErrorPage.module.less";

const Error404PageNoButtons = () => {
  return (
    <EmptyPage>
      <StreamlinedHeader hasPrevious={false} />
      <Body className={styles.body}>
        <ErrorContainer
          image={errorImages.Error404}
          imageAlt="Not Found"
          title="Oops!"
          description="We can't seem to find the page you've been looking for."
        />
      </Body>
    </EmptyPage>
  );
};

export default Error404PageNoButtons;
